const Fonts = {
    "Montserrat": "Montserrat",
    "Montserrat-Black": "Montserrat, Black",
    "Montserrat-BlackItalic": "Montserrat, BlackItalic",
    "Montserrat-Bold": "Montserrat, Bold",
    "Montserrat-BoldItalic": "Montserrat, BoldItalic",
    "Montserrat-ExtraBold": "Montserrat, ExtraBold",
    "Montserrat-ExtraBoldItalic": "Montserrat, ExtraBoldItalic",
    "Montserrat-ExtraLight": "Montserrat, ExtraLight",
    "Montserrat-ExtraLightItalic": "Montserrat, ExtraLightItalic",
    "Montserrat-Italic": "Montserrat, Italic",
    "Montserrat-Light": "Montserrat, Light",
    "Montserrat-LightItalic": "Montserrat, LightItalic",
    "Montserrat-Medium": "Montserrat, Medium",
    "Montserrat-MediumItalic": "Montserrat, MediumItalic",
    "Montserrat-Regular": "Montserrat, Regular",
    "Montserrat-SemiBold": "Montserrat, SemiBold",
    "Montserrat-SemiBoldItalic": "Montserrat, SemiBoldItalic",
    "Montserrat-Thin": "Montserrat, Thin",
    "Montserrat-ThinItalic": "Montserrat, ThinItalic"
}

export default Fonts;